import { ApisauceInstance } from 'apisauce';

const getCommitment = async (
  id: string,
  api: ApisauceInstance,
): Promise<Commitment | undefined> => {
  const response = await api.get<{ commitment: Commitment }>(
    `/v1/commitments/get_commitment?commitment_id=${id}`,
  );

  if (response.ok) {
    return response.data?.commitment;
  }

  return undefined;
};

export default getCommitment;
